import {Component, OnInit} from '@angular/core';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {ToggleComponent} from "@white-label/components/white-label/toggle/toggle.component";
import {FormsModule} from "@angular/forms";
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {
    StickerAdEditComponent
} from "@white-label/pages/admin-mode/widgets/sticker-ad/sticker-ad-edit/sticker-ad-edit.component";
import {ProductService} from "@cybfed/core/services/marketplace/product.service";
import {
    StickerAdItemComponent
} from "@white-label/pages/admin-mode/widgets/sticker-ad/sticker-ad-item/sticker-ad-item.component";
import {DynamicScaleDirective} from "@cybfed/core/utils/dynamic-scale.directive";
import {
    NotificationAdRenderComponent
} from "@white-label/pages/admin-mode/widgets/notification-ad/notification-ad-render/notification-ad-render.component";
import {
    StickerAdRenderComponent
} from "@white-label/pages/admin-mode/widgets/sticker-ad/sticker-ad-render/sticker-ad-render.component";

export enum EStickersAnimations {
    TORNADO = 'tornado',
    SINGLE = 'single',
    FIREWORK = 'firework',
    SNOW = 'snow',
    PUBGPLANE = 'pubg_plane',
    JACKPOT = 'jackpot',
    VULCANO = 'vulcano',
}
export interface ISticker {
    image: string,
    duration: number
}
export const StickerAnimations = [
    {
        key: "single",
        value: 1
    },
    {
        key: "tornado",
        value: 10
    },
    {
        key: "firework",
        value: 20
    },
    {
        key: "snow",
        value: 30
    },
    {
        key: "jackpot",
        value: 50
    },
    {
        key: "pubg_plane",
        value: 60
    },
    {
        key: "vulcano",
        value: 70
    },

]
import {PopupHelperService} from "@cybfed/core/services/popup-helper.service";
import {CopyLinkComponent} from "@white-label/components/copy-link/copy-link.component";
import {SafePipe} from "@cybfed/shared/pipes/safe.pipe";
@Component({
    selector: 'white-label-sticker-ad-dashboard',
    standalone: true,
    imports: [
        TranslateModule,
        ToggleComponent,
        FormsModule,
        StickerAdEditComponent,
        StickerAdItemComponent,
        DynamicScaleDirective,
        NotificationAdRenderComponent,
        StickerAdRenderComponent,
        CopyLinkComponent,
        SafePipe,
    ],
    providers: [ProductService],
    templateUrl: './sticker-ad-dashboard.component.html'
})
export class StickerAdDashboardComponent implements OnInit{
    selectedItem: any;
    animations: any = StickerAnimations
    stickersEnabled: any = false;
    public stickers: any = [];


    constructor(
        public whiteLabel: MainStoreService,
        private _productService: ProductService,
        private popupHelperService: PopupHelperService,
        private translateService: TranslateService,
    ) { }

    ngOnInit(): void {
        this._productService.getStickersProduct().subscribe((res) => {
            if (res.data.stickerProduct) {
                this.stickers = res.data.stickerProduct.services;
                if (res.data.stickerProduct.status === 'inactive') {
                    this.stickersEnabled = false;
                }else {
                    this.stickersEnabled = true;
                }
            }else{
                this.stickersEnabled = false;
            }
        })
    }

    testAnimation(animation: any) {
        console.log(animation)

        if(this.stickers.length > 0) {
            let services = this.getRandomServiceCounts(animation.value, this.stickers);
            console.log(animation);
            this._productService.testSicker(
                {
                    services,
                    metadata: {
                        animation: animation.key,
                        username: 'Fanbase.am',
                        message: 'Лудчая платформа для интерактивных донатов',
                        amount: '100 USD',

                    }
                }
            ).subscribe((data: any) => {
                if(!data.hasError){

                }
            });
        }

    }
    // I need angular component which will resceive array of object with images like this {image: string, duration: number} where duration is how long image will be visible in screen.
    getRandomServiceCounts(n:number, stickers: any) {
        // Object to hold the frequency counts
        const counts = {};

        // Randomly pick a service n times
        for (let i = 0; i < n; i++) {
            const randomService = stickers[Math.floor(Math.random() * stickers.length)]._id;
            counts[randomService] = (counts[randomService] || 0) + 1;
        }

        // Convert the counts object into an array of objects
        return Object.keys(counts).map(serviceId => ({
            serviceId,
            serviceCount: counts[serviceId]
        }));
    }

    saveSticker(event) {
        if (!event.mediaUrl) {
            this.popupHelperService.printError({ text: this.translateService.instant('media_file_required') });
            return;
        }

        if(this.selectedItem && this.selectedItem._id) {
            this._productService.updateService(this.selectedItem._id, event).subscribe((res) => {
                if (!res.hasError) {
                    this.popupHelperService.printSuccess();
                    if (res.data.service) {
                        let index = this.stickers.findIndex((x: any) => x._id === res.data.service._id);
                        this.stickers[index] = res.data.service
                    }
                } else {
                    this.popupHelperService.printError({ text: res.errorMessages[0].msg });
                }
            });
        }else {
            this._productService.addSticker(event).subscribe((res) => {
                if (!res.hasError) {
                    this.popupHelperService.printSuccess();
                    if (res.data.sticker) {
                        this.stickers.push(res.data.sticker);
                    }
                } else {
                    this.popupHelperService.printError({ text: res.errorMessages[0].msg });
                }
            });
        }

    }



    changeStickersStatus(event: any) {
        let updateData: any = {
            status: event?'active':'inactive'
        };
        this._productService.updateStickerProductStatus(updateData).subscribe((res) => {
            if (res.data.product) {
            }

        })
    }

    editItem(event: any) {
        if(event){
            this._productService.getServiceById(event).subscribe((data: any) => {
                if(!data.hasError){
                    this.selectedItem = data.data.service;
                }else {
                    this.popupHelperService.printError({text: data.errorMessages[0].msg})
                }
            })
        }else{
            this.selectedItem = null
        }

    }

    removeItem(event: any) {
        this._productService.deleteService(event).subscribe((data: any) => {
            if(!data.hasError){
                this.stickers = this.stickers.filter(sticker => sticker._id !== event);
                this.selectedItem = null;
            }else {
                this.popupHelperService.printError({text: data.errorMessages[0].msg})
            }
        })
    }

    cancelEdit(){
        this.selectedItem = null;
    }
}
